/**
 * Badge de descuento estable en PDP (evita parpadeo de WSAIO en .prod_saves).
 */
(function () {
  // Se observa el contenedor estable #price-<section-id> (no el .precioIVA
  // interno) porque el refresco de variante de renderProductInfo() reemplaza
  // el innerHTML de ese contenedor entero: si el observer estuviera en el
  // .precioIVA interno, quedaría huérfano en cuanto ese nodo se sustituye por
  // uno nuevo en el primer cambio de variante y dejaría de detectar cambios.
  const ROOT_SEL = '[id^="price-"]';
  const BADGE_SEL = '[data-b2b-discount-badge]';

  function parseMoney(text) {
    if (!text) return NaN;
    const cleaned = String(text).replace(/[^\d,.-]/g, '').trim();
    if (!cleaned) return NaN;

    const lastComma = cleaned.lastIndexOf(',');
    const lastDot = cleaned.lastIndexOf('.');

    if (lastComma > -1 && lastComma > lastDot) {
      return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    }

    return parseFloat(cleaned.replace(/,/g, ''));
  }

  function getPriceAmounts(root) {
    const priceProd = root.querySelector('.price.prod');
    if (!priceProd) return { compare: NaN, sale: NaN };

    const del = priceProd.querySelector('del .amount');
    const ins = priceProd.querySelector('ins .amount');

    return {
      compare: del ? parseMoney(del.textContent) : NaN,
      sale: ins ? parseMoney(ins.textContent) : NaN,
    };
  }

  function buildDiscountLabel(compare, sale) {
    if (!compare || !sale || compare <= sale) return '';
    const pct = Math.round((1 - sale / compare) * 100);
    if (pct <= 0) return '';
    return pct + '% Dto.';
  }

  function hideWsaioBadge(root) {
    root.querySelectorAll('.prod_saves').forEach((el) => {
      el.setAttribute('aria-hidden', 'true');
      el.style.display = 'none';
    });
  }

  function updateRoot(root) {
    const badge = root.querySelector(BADGE_SEL);
    if (!badge) return;

    hideWsaioBadge(root);

    const { compare, sale } = getPriceAmounts(root);
    const label = buildDiscountLabel(compare, sale);
    const key = compare + '|' + sale;

    if (badge.dataset.b2bDiscountKey === key) return;
    badge.dataset.b2bDiscountKey = key;

    if (label) {
      badge.textContent = label;
      badge.hidden = false;
      badge.classList.add('badge', 'onsale');
    } else {
      badge.textContent = '';
      badge.hidden = true;
      badge.classList.remove('badge', 'onsale');
    }
  }

  function watchRoot(root) {
    if (root.dataset.b2bBadgeWatched === 'true') return;
    root.dataset.b2bBadgeWatched = 'true';

    updateRoot(root);

    let timer;
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => updateRoot(root), 50);
    };

    new MutationObserver(() => schedule()).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const sectionId =
      root.closest('[data-section]')?.dataset?.section ||
      root.id?.replace('price-', '').replace('--sticky', '');

    if (sectionId) {
      document.addEventListener('product:variant-change', (event) => {
        if (event.detail?.sectionId === sectionId) {
          badgeClearCache(root);
          schedule();
        }
      });
    }

    window.addEventListener('load', schedule);
    setTimeout(schedule, 300);
    setTimeout(schedule, 1500);
  }

  function badgeClearCache(root) {
    const badge = root.querySelector(BADGE_SEL);
    if (badge) delete badge.dataset.b2bDiscountKey;
  }

  function init() {
    document.querySelectorAll(ROOT_SEL).forEach(watchRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El quick view inyecta su propio .precioIVA vía AJAX después de que este
  // script ya se ejecutó una vez, así que hay que volver a escanear cuando se abre.
  document.addEventListener('quick-view:open', init);
})();
